export interface PartyPlacementNotice {
  message: string;
  conflictCode?: string;
}

const CONFLICT_COPY: Readonly<Record<string, string>> = {
  ALREADY_IN_QUEUE:
    "A party member already has a queue or court spot. Review the refreshed status.",
  FACILITY_CLOSING:
    "There is no longer enough drop-in time for this placement.",
  PARTY_ALREADY_ACTIVE:
    "This party is already waiting or on court. Review the refreshed activity.",
  PARTY_HAS_EXPIRED_MEMBERS:
    "A party member is no longer checked in. Review who needs action.",
  PARTY_MEMBER_SESSION_TOO_SHORT:
    "A party member's session ends too soon for this placement.",
  PARTY_NOT_OPEN: "This party is no longer open for a new placement.",
  PARTY_STATE_CHANGED:
    "Party status changed. Review the refreshed party before trying again.",
  PARTY_TOO_LARGE: "This party no longer fits the selected court.",
  QUEUE_CLOSED: "Court placement is now paused at this facility.",
  QUEUE_STATE_CHANGED:
    "Court status changed. Review the refreshed court before trying again.",
  SELF_SERVE_LINES_REQUIRED:
    "Choose an available court before placing this party.",
  SELF_SERVE_NOT_ENABLED:
    "Court selection is no longer available at this facility.",
};

export function partyPlacementConflictNotice(
  error: unknown,
): PartyPlacementNotice {
  const code = (error as { code?: unknown } | null)?.code;
  const conflictCode = typeof code === "string" ? code : undefined;
  return {
    conflictCode,
    message:
      (conflictCode ? CONFLICT_COPY[conflictCode] : undefined) ??
      "Party or court status changed. Review the refreshed status before trying again.",
  };
}
